import { GetStaticProps, GetStaticPropsContext } from 'next';
import { RichText } from 'prismic-reactjs';
import dayjs from 'dayjs';

import {
  apolloClient,
  defaultQueryResult,
  getPageQuery,
} from 'utils/apolloClient';
import { getCurrentLocale } from 'utils/getCurrentLocale';
import { documentHtmlSerializer } from 'utils/htmlSerializers/documentHtmlSerializer';
import { PRIVACY_POLICY_QUERY } from '../../graphql/queries';
import {
  PrivacyPolicyQueryType,
  PrivacyPolicyType,
} from '../../models/pageTypes/document/privacy-policy';
import { PageQuery } from '../../graphql/model/PageQuery';
import { Page } from '../../models/pageTypes/page';
import { prepareSeoFromPageData } from '../../components/core/SEO/interface';
import {
  Content,
  Inner,
  LastUpdate,
  Title,
  Wrapper,
} from '../../styles/pages/styled/document.styles';

const PrivacyPolicy = ({ data: { page } }: Page<PrivacyPolicyType>) => {
  const lastUpdate = dayjs(page.last_update).format('D/MM/YYYY');

  return (
    <Wrapper>
      <Inner>
        <LastUpdate>
          {RichText.asText(page.last_update_title)}
          <span>{lastUpdate}</span>
        </LastUpdate>

        <Title>{RichText.asText(page.title)}</Title>

        <Content>
          <RichText
            render={page.content}
            htmlSerializer={documentHtmlSerializer}
          />
        </Content>
      </Inner>
    </Wrapper>
  );
};

export const getStaticProps: GetStaticProps = async (
  context: GetStaticPropsContext
) => {
  const currentLanguage: string = getCurrentLocale(context);

  const {
    data: { allDocument_pages, ...defaultData },
  } = await apolloClient.query<PageQuery<PrivacyPolicyQueryType>>(
    getPageQuery(
      { pageLang: currentLanguage },
      'top_articles',
      PRIVACY_POLICY_QUERY
    )
  );

  return {
    props: {
      data: {
        ...defaultQueryResult(defaultData),
        seo: prepareSeoFromPageData(allDocument_pages.edges[0].node),
        page: allDocument_pages.edges[0].node,
      },
    },
  };
};

export default PrivacyPolicy;
